


































import Vue from 'vue'
import { Button } from '@raksul/raksul-common-ui'
import ModalOverlay from '@/common/components/ModalOverlay.vue'

export default Vue.extend({
  components: { ModalOverlay, Button },
  props: {
    image: {
      type: String,
      required: true
    }
  },
  methods: {
    closeModal(): void {
      this.$emit('close')
    }
  }
})
